import { render, staticRenderFns } from "./SummaryStep.vue?vue&type=template&id=bb4c3fe6"
import script from "./SummaryStep.vue?vue&type=script&lang=ts"
export * from "./SummaryStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports